export default __webpack_public_path__ + "static/media/1013.33cbefd0.png";